module.exports = __webpack_public_path__ + "static/media/IGC.dd833268.jpg";